import { fromJS } from 'immutable';

import * as constants from 'actions/orders/constants';
import uiRecord from 'reducers/ui/records';

export const initialState = uiRecord();

export default (state = initialState, action) => {
  switch (action.type) {
    case constants.GET_SKUS:
      return uiRecord({
        loader: true
      });

    case constants.GET_SKUS_SUCCESS:
      return uiRecord();

    case constants.GET_SKUS_ERROR:
      return uiRecord({
        error: fromJS(action.error)
      });

    default:
      return state;
  }
};
